import { Typography, Box, accordionSummaryClasses } from "@mui/material";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import { MzAccordion, MzAccordionSummary, MzAccordionDetails } from "@markaaz/ui/MzAccordionControls";
import MzTooltip from "@markaaz/ui/MzTooltip";

const sx = {
  root: {
    [`.${accordionSummaryClasses.expandIconWrapper}`]: {
      display: "none"
    }
  },
  stack: {
    width: "100%"
  },
  accordionSummary: {
    paddingLeft: 5,
    paddingRight: 5
  }
};

export default function TracePanel({ title, data }) {
  let json = data;

  if (data) {
    try {
      const jsonData = typeof data === "string" ? JSON.parse(data) : data;
      json = JSON.stringify(jsonData, null, 4);
    } catch (error) {
      console.log(error);
    }
  }

  function handleCopy() {
    navigator.clipboard.writeText(json);
  }

  return (
    <Box sx={sx.root}>
      <MzAccordion expanded={true}>
        <MzAccordionSummary sx={sx.accordionSummary}>
          <Stack sx={sx.stack} direction="row" alignItems="center" justifyContent="space-between">
            <Typography ml={2} variant="body1B" marginLeft={0}>
              {title}
            </Typography>
            <MzTooltip placement="top" title="Copy All">
              <IconButton size="small" onClick={handleCopy}>
                <ContentCopyRoundedIcon fontSize="inherit" color="primary" />
              </IconButton>
            </MzTooltip>
          </Stack>
        </MzAccordionSummary>
        <MzAccordionDetails sx={{ p: 4 }}>
          <Typography component="pre" variant="body2" color="darkBlue.c100">
            {json}
          </Typography>
        </MzAccordionDetails>
      </MzAccordion>
    </Box>
  );
}
